import React, { useState } from "react";
import moment from "moment";
import { useUpdateVehicleDetailMutation } from "../vehicleSlice";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@material-ui/core";
import DatePicker from "../../../components/DatePicker";
import { useGetLotsQuery } from "../../lots/lotSlice";
import CustomInput from "../../../components/CustomInput";
import { vehicleDetailsPageStyle } from "./VehicleDetailsPageStyle";
import { getLotsWithPmfText } from "../../../features/lots/lotUtil";
import { DateTimePicker } from "@mui/x-date-pickers";
import DateTimeField from "components/DateTimePicker/DateTimePicker";

const EditVehicleDetails = ({
    onCancel,
    vehicleDetails,
    onConfirm,
    vehicleId
}) => {
    const classes = vehicleDetailsPageStyle();
    const [date, setDate] = useState(moment(vehicleDetails?.formattedDate));
    const [updateVehicleDetails, { isLoading }] = useUpdateVehicleDetailMutation();
    let { data: lots, error: getLotsError, isLoading: loadingLots } = useGetLotsQuery();
    const [selectedLot, setSelectedLot] = useState(vehicleDetails?.lotId);
    const [mileage, setMileage] = useState(vehicleDetails?.mileage);

    const save = async () => {
        let dateToSave = new Date(moment(date).format("YYYY-MM-DD, hh:mm a") + " UTC");
        let activityDate = dateToSave.toISOString();
        try {
            await updateVehicleDetails({ id: vehicleDetails.vehicleDetailsId, createdDate: activityDate, lot: selectedLot, vehicleId: vehicleId, mileage });
            onConfirm(vehicleDetails.vehicleDetailsId, date);
        } catch (err) {
        }
    };


    return (
        <Dialog open={!!vehicleDetails} onClose={() => onCancel(false)} aria-labelledby='dialog-title'>
            <DialogTitle id={'dialog-title'} >Edit Activity</DialogTitle>
            <DialogContent>
                {isLoading && <LoadingSpinner loading={isLoading} />}
                <div className={classes.input}>
                    <CustomInput
                        id="lot"
                        label="Lot"
                        value={selectedLot}
                        elementType="dropdown"
                        showEmpty={true}
                        required={false}
                        onChange={val => setSelectedLot(val)}
                        values={getLotsWithPmfText(lots)}
                    />
                </div>
                <div className={classes.input}>
                    {/* <DateTime
                        title="Date"
                        value={date}
                        onSelect={setDate} /> */}
                    <DateTimeField
                        label='Activity Date'
                        value={date}
                        onChange={setDate}
                        required={true}
                    />
                </div>
                <div className={classes.input}>
                    <CustomInput
                        label={'Mileage'}
                        value={mileage}
                        onChange={setMileage} />
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color='primary'>
                    Cancel
                </Button>
                <Button onClick={save} color='primary' variant="contained">
                    {isLoading ? 'Saving...' : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditVehicleDetails;
